import { createSlice } from "@reduxjs/toolkit";

export const stimeSlice = createSlice({
    name: 'stime',
    initialState: {
        stime: null,
        stimeMinime: null,
        stimeInserite: null,
        stimaGlobale: null,
    },
    reducers: {
        setStime: (state, action) => {
            state.stime = action.payload
        },
        setStimeMinime: (state, action) => {
            state.stimeMinime = action.payload
        },
        setStimeInserite: (state, action) => {
            state.stimeInserite = action.payload
        },
        setStimaGlobale: (state, action) => {
            state.stimaGlobale = action.payload
        }
    }
});

export const { setStime, setStimeMinime, setStimeInserite, setStimaGlobale } = stimeSlice.actions;
export default stimeSlice.reducer;